import dynamic from "next/dynamic";
const TestSection = dynamic(() => import("../components/TestSection"));
const Form = dynamic(() => import("../components/Form"));
const Image = dynamic(() => import("next/image"));
import Head from "next/head";

import { motion } from "framer-motion";
import React, { useRef } from "react";
import { client } from "../../lib/client";
import { NextSeo } from "next-seo";
import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";
import Link from "next/link";

const SeoComponents = () => (
  <Head>
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://techcelerant.com/testimonials" />
    <title>Reviews & Testimonials | Techcelerant</title>
    <meta name="description" content="Precesion In Progress" />
    <meta
      name="description"
      content="The Techcelerant team is sharp, agile, and swift. Highly responsive and technically savvy, they embody a rare sense of urgency, consistently delivering on time. Read more"
    />
    <link rel="apple-touch-icon" href="apple-touch-icon.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" href="/favicon.ico" />
  </Head>
);

const Testimonials = ({ testimonialsPage }) => {
  const { seo, pageBuilder } = testimonialsPage;

  const { testimonials_firstSection, testimonials_SecondSection } = pageBuilder;

  const { metaDescription, metaTitle } = seo;

  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 100,
  };
  const ref = useRef();

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical="https://techcelerant.com/about"
      />

      <SeoComponents />
      <div
        style={{ "--bg-02": "white", color: "black", "--bg-op": "0.05" }}
        className="hidden sm:block sm:pt-[50px] min-h-screen pb-5 flex flex-col body-top-section-rotate "
      >
        <motion.div
          transition={spring}
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          className="flex flex-col justify-start sm:items-center max-w-[80rem] m-auto pt-20 "
        >
          <div className="flex items-start justify-center pt-[2rem]">
            <div className="min-w-[50%]">
              <h1
                className={` text-start  text-[40px] sm:text-[60px] text-black  ${GilroyFontDark.className} `}
              >
                {testimonials_firstSection?.t1_first_heading}
              </h1>
              <h3
                style={{ fontWeight: 300 }}
                className={` text-start text-[36px] pb-3  ${GilroyFontDark.className} `}
              >
                {" "}
                {testimonials_firstSection?.t1_first_paragraph}
              </h3>
              <p
                style={{ fontWeight: 300, lineHeight: "40px" }}
                className={` text-start text-[24px] w-[90%]  ${GilroyFontLight.className} `}
              >
                {testimonials_firstSection?.t1_second_paragraph}
              </p>
              <p className='font-bold text-[15px] text-black italic mt-4'>Highly Recommended & Trusted By</p>
    <div className='flex gap-3 sm:gap-8 justify-start '>
    <Link href={`https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LEsyqEw3T8s2YLRSMahINLU0NEyxMEkyT0oxNjUxtDKoMDdKszQ1szA1NzdJMTA39-IpSU3OSE7NSS1KzCsBAHJXE0E&q=techcelerant&oq=techcele&gs_lcrp=EgZjaHJvbWUqDQgCEC4YrwEYxwEYgAQyBggAEEUYPDIGCAEQRRg8Mg0IAhAuGK8BGMcBGIAEMgYIAxBFGDkyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEINDk4MmowajGoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0xa5911d84b7bd3541:0x72f95685774d077,1,,,,`} target='_blank'>
    <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev1.png"
                      />
                      </Link>
                      <Link href={`https://www.trustpilot.com/review/techcelerant.com`} target="_blank">
                      <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev2.png"
                      />
                      </Link>

    </div>
            </div>
            <div className="min-w-[50%] z-10">
              <Image
                priority="true"
                width={1000}
                height={1000}
                alt="two men sitting on a table signing a contract"
                src={testimonials_firstSection?.t1_first_image}
              />
            </div>
          </div>
        </motion.div>
      </div>

      <section
        style={{ "--website-bg-02": "black" }}
        className="h-auto -mt-20 pb-2  pt-20 body-top-section-rotate-3 mt-auto"
      >
        <TestSection ref={ref} testData={testimonials_SecondSection} />
      </section>

      <div className="bg-black sm:flex flex-col items-center pb-[5rem]  sm:px-5 -ml-6 sm:ml-0">
        <Form isAnimate={true} isVisible={true} />
      </div>
    </>
  );
};
export default Testimonials;

export const getServerSideProps = async () => {
  // context.res.setHeader('Cache-Control', 'public, max-age=300');
  const query = `*[ _type == "testimonials"][0]`;
  const testimonialsPage = await client.fetch(query);

  return {
    props: {
      testimonialsPage,
    },
  };
};
